import TurndownService from 'turndown';

import HTMLBaseExportProvider from './htmlBase.provider';

const cleanAttribute = attribute => (attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : '');

export default class MarkdownExportProvider extends HTMLBaseExportProvider {
  static EXTENSION = 'md';

  static async exportNote({ note, editor, store }) {
    // Set editor data to current note
    MarkdownExportProvider.setEditorContent(editor, note.content);

    const content = await MarkdownExportProvider.renderContent({
      store,
      noteUuid: note.uuid,
      content: editor.getHTML(),
    });

    const turndownService = new TurndownService({
      headingStyle: 'atx',
      hr: '---',
      bulletListMarker: '-',
      codeBlockStyle: 'fenced',
      emDelimiter: '*',
    });

    turndownService.addRule('image', {
      filter: 'img',
      replacement: (content, node) => {
        const alt = cleanAttribute(node.getAttribute('alt'));
        const src = node.getAttribute('src') || '';
        const title = cleanAttribute(node.getAttribute('title'));
        const titlePart = title ? ` "${title}"` : '';
        return src ? `\n\n![${alt}](${src}${titlePart})\n\n` : '';
      },
    });
    turndownService.addRule('listItem', {
      filter: 'li',
      replacement: (content, node, options) => {
        content = content
          .replace(/^\n+/, '') // remove leading newlines
          .replace(/\n+$/, '\n') // replace trailing newlines with just a single one
          .replace(/\n/gm, '\n    '); // indent

        let prefix;
        const parent = node.parentNode;

        if (parent.nodeName === 'OL') {
          const start = parent.getAttribute('start');
          const index = Array.prototype.indexOf.call(parent.children, node);
          prefix = `${start ? Number(start) + index : index + 1}. `;
        } else if (parent.nodeName === 'UL') {
          if (node.dataset.type === 'todo_item') {
            const done = node.dataset.done === 'true' ? 'x' : ' ';
            prefix = `${options.bulletListMarker} [${done}] `;
          } else {
            prefix = `${options.bulletListMarker}   `;
          }
        }

        return prefix + content + (node.nextSibling && !/\n$/.test(content) ? '\n' : '');
      },
    });

    const data = turndownService.turndown(content);

    // Reset the editor data
    MarkdownExportProvider.setEditorContent(editor, null);

    return data;
  }
}
